import { Injectable } from '@angular/core';
import { ByaHttp } from '../../services/bya-http';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AuthService } from '../../../@bya/auth/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ByaHttp {


    constructor(
        private http: HttpClient,
		protected dialog: MatDialog, private _authService: AuthService) {
		super(dialog, _authService);
    }


    GetUltimoInicioSesion(): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/User/UltimoInicioSesion')
            .pipe(
                tap(_ => this.log('')),
                catchError(this.handleError<any>('', null))
            );
    }


}
